import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ModalOption General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalOption.';

  public static readonly ok = `${Id.prefix}ok`;
  public static readonly information = `${Id.prefix}information`;
  public static readonly confirm = `${Id.prefix}confirm`;
}

export class LangModalOption {
  private constructor() {}

  public static ok(): string {
    return interpolate(Id.ok);
  }
  public static information(): string {
    return interpolate(Id.information);
  }
  public static confirm(): string {
    return interpolate(Id.confirm);
  }
}

export class ModalOptionModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.ok, 'Ok', 'Ok button');
    register.add(Id.information, 'Information', 'Information dialog title');
    register.add(Id.confirm, 'Confirm', 'Confirm dialog title');
  }
}
